module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "pb-2": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-3 px-2 layout row wrap"
  }, [_c('v-btn', {
    staticClass: "primary my-0 mx-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createRegister()
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$lang.actions.createCashRegister) + "\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    staticClass: "min-w max-w mx-3 pb-2",
    attrs: {
      "label": _vm.$lang.actions.selectCompany,
      "items": _vm.mappedCompanies,
      "hide-details": ""
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedCompany || (_vm.isLocalAdmin && _vm.allRegisters)) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.allRegisters,
      "headers": _vm.headers,
      "loading": _vm.loading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.cashRegisterName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.inUseFrom ? _vm.formatDate(props.item.inUseFrom) : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editRegister(props.item.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$lang.actions.edit))])], 1)]
      }
    }], null, false, 3758158573)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a49d7b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cashRegister/CashRegister.vue
// module id = 382
// module chunks = 35